import _ from 'underscore';
import { BundleCouponClassCodes } from '@bingads-webui-campaign-react/promotion-utils';
import { formatCost, couponTypes } from '../helpers';

export const couponText = ({ i18n, couponDetails, currencyCode }) => {
  let text = '';
  if (couponDetails && currencyCode) {
    const couponAmount = formatCost(couponDetails.CouponValue, i18n, currencyCode);
    if (couponDetails.CouponTypeId === couponTypes.Percent) {
      text = i18n.getString(
        _TL_('Get {{ percentOff }}% off (up to {{ couponAmount }}) of your search advertising spend for {{ numberOfDays }} days.'),
        {
          percentOff: couponDetails.PercentOff,
          couponAmount,
          numberOfDays: couponDetails.LimitForDaysToUseFromCustomerCreation,
        }
      );
    } else if (couponDetails.CouponTypeId === couponTypes.Performance) {
      const upfrontSpendAmount = formatCost(couponDetails.UpfrontSpending, i18n, currencyCode);
      text = i18n.getString(_TL_('Spend {{ upfrontSpendAmount }} get {{ couponAmount }} off.'), { upfrontSpendAmount, couponAmount });

      // overwrite if met the requirement
      if (_.include(BundleCouponClassCodes, couponDetails.ClassName)) {
        const maxValueAmount = formatCost(500, i18n, currencyCode);
        text = i18n.getString(_TL_('Spend {{ upfrontSpendAmount }} get {{ couponAmount }} off, with a maximum discount of {{maxValueAmount}}.'), { upfrontSpendAmount, couponAmount, maxValueAmount });
      }
    } else {
      text = i18n.getString(_TL_('Sign up bonus {{ couponAmount }}.'), { couponAmount });
    }
  }
  return text;
};

export const getMultiCouponDescription = (i18n, coupon, currencyCode) => {
  let text = '';
  if (coupon && currencyCode) {
    const couponAmount = formatCost(coupon.CouponValue, i18n, currencyCode);
    if (coupon.CouponTypeId === couponTypes.Percent) {
      text = i18n.getString(
        _TL_('Save {{ percentOff }}% on all advertising spend, up to {{ couponAmount }} off.'),
        {
          percentOff: coupon.PercentOff,
          couponAmount,
        }
      );
    } else {
      text = couponText({ i18n, couponDetails: coupon, currencyCode });
    }
    // overwrite if met the requirement
    if (_.include(BundleCouponClassCodes, coupon.ClassName)) {
      text = i18n.getString(_TL_('Get {{ couponAmount }} for every  {{ upfrontSpendAmount }} you spend, with a maximum discount of {{maxValueAmount}}.'), {
        couponAmount,
        upfrontSpendAmount: formatCost(coupon.UpfrontSpending, i18n, currencyCode),
        maxValueAmount: formatCost(500, i18n, currencyCode),
      });
    }
  }
  return text;
};
